var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeftArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.75 13.7499H8.91875L13.46 8.29995C13.9025 7.76995 13.83 6.9812 13.3 6.53995C12.7687 6.09745 11.9812 6.16995 11.54 6.69995L5.29 14.1999C5.24125 14.2587 5.21625 14.3274 5.18 14.3924C5.15 14.4449 5.11375 14.4899 5.09125 14.5474C5.035 14.6912 5.00125 14.8424 5.00125 14.9949C5.00125 14.9962 5 14.9987 5 14.9999C5 15.0012 5.00125 15.0037 5.00125 15.0049C5.00125 15.1574 5.035 15.3087 5.09125 15.4524C5.11375 15.5099 5.15 15.5549 5.18 15.6074C5.21625 15.6724 5.24125 15.7412 5.29 15.7999L11.54 23.2999C11.7875 23.5962 12.1425 23.75 12.5 23.75C12.7825 23.75 13.0662 23.655 13.3 23.46C13.83 23.0187 13.9025 22.2299 13.46 21.7L8.91875 16.2499H23.75C24.44 16.2499 25 15.6899 25 14.9999C25 14.3099 24.44 13.7499 23.75 13.7499Z",
    fill: "#BF7247"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrow);
export default __webpack_public_path__ + "static/media/left-arrow.27b0dc3f.svg";
export { ForwardRef as ReactComponent };